import { render, staticRenderFns } from "./IconFocusAdd.vue?vue&type=template&id=520ff74b&scoped=true&"
import script from "./IconFocusAdd.vue?vue&type=script&lang=js&"
export * from "./IconFocusAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ff74b",
  null
  
)

export default component.exports